import { FormProvider, useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { z } from "zod"
import { booleanRequired } from "@/models/common"
import { formDirtySchema } from "@/modules/patients/detail/progress-note/components/progress-note-editable/treatment-plan-section"
import { QuestionnaireForm } from "@/modules/patients/detail/progress-note/components/questionnaire-form"
import { useProgressNoteQuestionSummaryForm } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteQuestionSummaryForm"
import { useProgressNoteQuestionSummaryFormEffect } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteQuestionSummaryFormEffect"
import { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { QuestionnaireCriticalitySummaryFragment$data } from "@/modules/patients/services/__generated__/QuestionnaireCriticalitySummaryFragment.graphql"

export const questionnaireSchema = z
  .object({
    questionnaireStatus: booleanRequired,
  })
  .extend(formDirtySchema.shape)

export type QuestionnaireFormType = z.infer<typeof questionnaireSchema>

interface QuestionnaireProps {
  episodeOfCareProgressNoteData: EpisodeOfCareProgressNoteData
  criticalitySummary: QuestionnaireCriticalitySummaryFragment$data | null | undefined
  diagnosisCode?: string
}

const Questionnaire = (props: QuestionnaireProps) => {
  const { episodeOfCareProgressNoteData, criticalitySummary, diagnosisCode } = props

  const { appointment, id } = episodeOfCareProgressNoteData
  const { defaultValues, storeFormState } = useProgressNoteQuestionSummaryForm(id, appointment.asyncRequestStatus)

  const form = useForm<QuestionnaireFormType>({
    resolver: zodResolver(questionnaireSchema),
    defaultValues: defaultValues,
  })

  useProgressNoteQuestionSummaryFormEffect(id, episodeOfCareProgressNoteData, storeFormState, form)

  return (
    <FormProvider {...form}>
      <QuestionnaireForm
        appointment={appointment}
        criticalitySummary={criticalitySummary}
        progressNoteId={id}
        diagnosisCode={diagnosisCode}
      />
    </FormProvider>
  )
}

export { Questionnaire }
